import { getWidthOfString } from "@/utils/getWidthOfString";
import useOuterClick from "@/utils/useOuterClick";
import { useMemoizedFn } from "ahooks";
import { Checkbox, Dropdown } from "antd";
import classNames from "classnames";
import { drop } from "lodash";
import { useMemo, useRef } from "react";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

interface ISubjectSelectProps {
  value: any[];
  onChange: (value: any[]) => void;
  options: {
    value: any;
    label: string;
  }[];
}

export function SubjectSelect(props: ISubjectSelectProps) {
  const { value, onChange, options } = props;
  const dropDownRef = useRef<HTMLDivElement>(null);
  const [ref, visible, setVisibel] = useOuterClick(false, {
    extraTargets: [dropDownRef],
  });

  const onToogle = useMemoizedFn((item) => {
    if (value?.includes?.(item.value)) {
      onChange(value.filter((v) => v !== item.value));
    } else {
      onChange([...value, item.value]);
    }
  });
  // option在输入框占据宽度计算缓存
  const optionWidthRef = useRef({});
  const dropdownContent = useMemo(() => {
    return (
      <div className={styles.subjectDropdown} ref={dropDownRef}>
        {options.map((item) => {
          const checked = value.includes(item.value);
          return (
            <Checkbox
              className={classNames(
                styles.subjectItem,
                styles.checkBox,
                styles.blackTheme,
                {
                  [styles.active]: checked,
                }
              )}
              key={item.value}
              checked={checked}
              onChange={() => onToogle(item)}
            >
              <div className={styles.label}>{item.label}</div>
            </Checkbox>
          );
        })}
      </div>
    );
  }, [onToogle, options, value]);

  //选中内容输入框内渲染tag
  const selectedContent = useMemo(() => {
    const widthMap = optionWidthRef.current;
    const maxWidth = 290;
    /**已渲染宽度 */
    let renderedWidth = 0;

    return value.map((item, index) => {
      // 剩下超出宽度的选项不展示
      if (renderedWidth > maxWidth) {
        return;
      }

      const option = options.find((opt) => opt.value === item);
      if (!option) {
        return;
      }

      if (!widthMap[option.value]) {
        // 计算占据宽度，字符串宽度 + 叉叉图标（18） + 边距（20）
        widthMap[option.value] = Math.min(
          getWidthOfString(option.label) + 16 + 20,
          204
        );
      }

      // 增加当前渲染宽度
      renderedWidth += widthMap[option.value];

      // 第一个超出宽度了，展示省略号，hover展示剩余选项
      if (renderedWidth > maxWidth) {
        return (
          <Dropdown
            key={item.value}
            placement="topCenter"
            overlayClassName={styles.restOverlay}
            overlay={
              <div className={styles.restOverlayContent}>
                {drop(value, index).map((v) => {
                  const option = options.find((opt) => opt.value === v);
                  return (
                    <div className={styles.item} key={v}>
                      <div className={styles.label} title={option.label}>
                        {option.label}
                      </div>
                      <HBIcon
                        type="ic_close"
                        className={styles.closeIcon}
                        onClick={(e) => {
                          e.stopPropagation();
                          onToogle(option);
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            }
          >
            <div className={styles.renderTag} key={item.value}>
              ...
            </div>
          </Dropdown>
        );
      }

      return (
        <div className={styles.renderTag} key={item.value}>
          <div className={styles.text}>{option.label}</div>
          <HBIcon
            type="ic_close"
            className={styles.closeIcon}
            onClick={(e) => {
              e.stopPropagation();
              onToogle(option);
            }}
          />
        </div>
      );
    });
  }, [onToogle, options, value]);

  return (
    <Dropdown
      visible={visible}
      // open
      overlayClassName={styles.subjectSelectDropdown}
      overlay={dropdownContent}
      destroyPopupOnHide
    >
      <div
        ref={ref}
        className={styles.subjectSelect}
        onClick={() => setVisibel((prev) => !prev)}
      >
        {selectedContent}
        <HBIcon
          type="ic_arrow_drop_down"
          className={classNames(styles.selectArrow, {
            [styles.expand]: visible,
          })}
        />
      </div>
    </Dropdown>
  );
}
